import { signal, Signal } from '@angular/core';

/** Canonical capability names available to application consumers. */
// eslint-disable-next-line @typescript-eslint/typedef
export const CapabilityNames = [
  // Platform
  'platform.forceNativeAppUpdate',
  'platform.cmsAppConfigMode',
  'platform.publicApp',

  // Account
  'account',
  'account.employeeAdministration',
  'account.customerBlockingCheck',

  // Services
  'services.srm',
  'services.srmTicketSuggestion',
  'services.orderHistoryDeliveryFilter',
  'services.documents',

  // Shop
  'shop',
  'shop.referenceText',
  'shop.requestedDeliveryDate',
  'shop.newCheckoutUi',
  'shop.orderVouchers',
  'shop.shoppingListDownload',
  'shop.orderReorder',
  'shop.orderExtendedDeposit',
] as const;

export type CapabilityName = typeof CapabilityNames[number];

export type CapabilityAccessResultNeutral = undefined;
export type CapabilityAccessResultGranted = true;
export type CapabilityAccessResultDenied = false;
export type CapabilityAccessResult = CapabilityAccessResultNeutral | CapabilityAccessResultGranted | CapabilityAccessResultDenied;

/**
 * Extensible capability source. Return `true` to grant, `false` to deny, or
 * `undefined` when this checker does not own the capability.
 */
export abstract class CapabilityAccessChecker {
  protected readonly neutralResult: Signal<CapabilityAccessResultNeutral> = signal(undefined);

  public abstract canUse(name: CapabilityName): Signal<CapabilityAccessResult>;
}
